import {
  ADD_PLANNED_DATA,
  FETCH_PLAN_SCHEDULE,
  FETCH_PLAN_LIST,
  FETCH_DETAIL,
  UPDATE_DATA,
  GET_TEMPLATE,
  GET_AIRPORTS_DATA,
  FETCH_GATES_LIST,
  FETCH_REQUEST_LOGS,
  GET_REQUEST_LOG,
  GATE_REQUEST_UPDATE,
  FETCH_ALLOCATION_DATA,
  CLEAR_DATA
} from './types';

const BACKEND_API = 'BACKEND_API';

export const savePlanData = data => ({
  type: BACKEND_API,
  payload: {
    method: 'post',
    url: '/gate_schedule/',
    data,
    ...ADD_PLANNED_DATA
  }
});

export const getPlanSchedule = () => ({
  type: BACKEND_API,
  payload: Object.assign(
    {
      method: 'get',
      url: '/gate_schedule/'
    },
    FETCH_PLAN_SCHEDULE
  )
});

export const getPlanList = id => ({
  type: BACKEND_API,
  payload: Object.assign(
    {
      method: 'get',
      url: `/gate_schedule/${id}/get_planned_data/`
    },
    FETCH_PLAN_LIST
  )
});

export const getdetail = id => ({
  type: BACKEND_API,
  payload: Object.assign(
    {
      method: 'get',
      url: `/gate_plan/${id}/`
    },
    FETCH_DETAIL
  )
});

export const updateData = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'patch',
    url: `/gate_plan/${id}/`,
    data,
    ...UPDATE_DATA
  }
});

export const getTemplate = () => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: '/gate_schedule/get_template/',
    ...GET_TEMPLATE
  }
});

export const getGateList = () => ({
  type: BACKEND_API,
  payload: Object.assign(
    {
      method: 'get',
      url: '/gate/'
    },
    FETCH_GATES_LIST
  )
});

export const searchAirports = query => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: `/diversion_logs/get_airport_data/?q=${query}`,
    ...GET_AIRPORTS_DATA
  }
});

export const createGateRequest = data => ({
  type: BACKEND_API,
  payload: {
    method: 'post',
    url: '/gate_request/',
    data,
    ...GATE_REQUEST_UPDATE
  }
});

export const fetchGateRequestLogs = (page, pagesize, query) => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: `/gate_request/?q=${query}`,
    ...FETCH_REQUEST_LOGS
  }
});

export const getGateRequest = id => ({
  type: BACKEND_API,
  payload: Object.assign(
    {
      method: 'get',
      url: `/gate_request/${id}`
    },
    GET_REQUEST_LOG
  )
});

export const fetchGateAllocationData = (s1, s2, allocation) => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: `/gate_activity/?&start=${s1}&end=${s2}&allocation=${allocation}`,
    ...FETCH_ALLOCATION_DATA
  }
});

export const clearData = () => ({
  type: CLEAR_DATA
});
